import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-54af2c40")

_pushScopeId("data-v-54af2c40")
const _hoisted_1 = { class: "page-section flex flex--width flex--v flex--valign-c flex--gap-50" }
const _hoisted_2 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_3 = { class: "text text--primary-gradient text--bold text--size-30" }
const _hoisted_4 = { class: "text text--accent-gray-b text--medium text--size-20 text--less-gap text--center" }
const _hoisted_5 = { class: "page-section flex flex--v flex--valign-c flex--gap-50" }
const _hoisted_6 = { class: "flex flex--v flex--valign-c flex--gap-10" }
const _hoisted_7 = { class: "text text--primary-gradient text--bold text--size-30" }
const _hoisted_8 = { class: "text text--accent-gray-b text--medium text--size-20 text--less-gap text--center" }
const _hoisted_9 = {
  id: "startOfFindCompany",
  class: "flex flex--v fkex--valign-c"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FindCompanySkills = _resolveComponent("FindCompanySkills")
  const _component_FindCompanyEconomicSectorOptions = _resolveComponent("FindCompanyEconomicSectorOptions")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    title: _ctx.$trans('navigation.nav_find'),
    "title-id": 'startOfJobfuchs'
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$trans("main.find-skills-headline")), 1),
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$trans("main.find-skills-subheadline")), 1)
        ]),
        _createVNode(_component_FindCompanySkills, {
          "qualification-groups": _ctx.qualificationGroups,
          "qualification-input": _ctx.qualificationInput,
          onQualificationValueChanged: _cache[1] || (_cache[1] = (qualificationId, value) => _ctx.$emit('qualificationValueChanged', qualificationId, value))
        }, null, 8, ["qualification-groups", "qualification-input"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$trans("main.find-choose-headline")), 1),
          _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$trans("main.find-choose-subheadline")), 1)
        ]),
        _createVNode(_component_FindCompanyEconomicSectorOptions, {
          sectors: _ctx.economicSectors,
          "selected-sectors": _ctx.selectedEconomicSectors,
          onSectorValueChanged: _cache[2] || (_cache[2] = (value) => _ctx.$emit('economicSectorValueChanged', value))
        }, null, 8, ["sectors", "selected-sectors"])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_GenericButton, {
          title: _ctx.$trans('search.btn_search'),
          identifier: 'djf_update_search',
          searching: _ctx.searchingProcess,
          "omit-icon-when-s-m": false,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clickFindCompany')))
        }, null, 8, ["title", "searching"])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
})